"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { captureSignupAttribution } from "@/lib/signup-attribution-client";

export function AttributionCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => {
    captureSignupAttribution();
  }, [pathname, searchParams]);

  return null;
}
